<template>
  <div>
    <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; padding-left: 50px; font-size: 14px;" :flat='true'>
      <p>
        <b :style="{color: $mainColor}">«Современные подходы к созданию детекторных материалов»</b>
      </p>
      <p>
        Школа молодых ученых проводится в целях ознакомления молодых исследователей с последними достижениями и тенденциями в области материалов для детекторов ионизирующих излучений, а также их применения. Мероприятие призвано создать уникальную научную атмосферу для открытого профессионального общения, способствующую повышению квалификации и компетенций участников, раскрытию интеллектуального потенциала молодых учёных и налаживанию совместной работы в этом перспективном направлении.
      </p>
      <p>
        В рамках школы будут рассмотрены вопросы теории и практики детекторных материалов – от фундаментальных аспектов взаимодействия излучения с веществом до прикладных технологий. Программа охватывает моделирование сцинтилляционных процессов, спектроскопию перспективных материалов, оптимизацию свойств керамических материалов с содопированием, разработку порошковых сцинтилляторов и композитных экранов, аддитивные технологии, радиационную чистоту материалов и детекторы нейтронов.
      </p>
      <p>
        Приглашаем принять участие в работе школы ведущих ученых и экспертов в области детекторов ионизирующих излучений, а также молодых ученых и специалистов в возрасте до 35 лет включительно, аспирантов (ординаторов, интернов), студентов очной формы обучения, работников и членов экспертных советов Российского научного фонда.
      </p>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

const reEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

export default {
  name: 'HomePage',
  data() {
    return {

    };

  },
};
</script>

<style scoped>
.custom-list {
  list-style: none; 
  padding-left: 0;
}

.custom-list li {
  position: relative;
  padding-left: 24px;
  margin-bottom: 8px;
}

.custom-list li::before {
  content: "✓"; 
  position: absolute;
  left: 0;
  color: #185ba6;
  font-weight: bold;
}
</style>

<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgb(0, 0, 0);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
}
</style>